import React, { useState, useRef, useEffect } from 'react';
import MainLinks from "../components/navlinks/MainLinks"
import Body from "../components/body/BodyPage"
import { useTranslation } from "react-i18next";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBSelect,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
    MDBFile,
    MDBIcon,
    MDBInput,
    MDBContainer,
    MDBAutocomplete,
    MDBRadio,
    MDBDatatable,
    MDBCheckbox,
    MDBPopconfirm,
    MDBPopconfirmMessage,
    MDBChip,
    MDBTooltip,
    MDBRow,
    MDBCol,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBScrollspySubList,
    MDBTextArea,
    MDBPagination,
    MDBPaginationItem,
    MDBPaginationLink,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBCard,
    MDBCardBody,
    MDBTimepicker,
    MDBInputGroup,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBListGroupItem,
    MDBListGroup,
    MDBBadge
} from 'mdb-react-ui-kit';
import {
    MDBStepper,
    MDBStepperStep,
} from 'mdb-react-ui-kit';
import { Tooltip } from "react-tooltip";
import { SeqArrow } from '../components/images';
// import CustomAudioPlayer from '../components/audioPlayer/CustomAudioPlayer';
// import Audio from "../components/mediaplayers/town-10169.mp3"; 



const countries = [
    { code: '+1', name: 'United States' },
    { code: '+44', name: 'United Kingdom' },
    { code: '+91', name: 'India' },
    { code: '+81', name: 'Japan' },
    { code: '+61', name: 'Australia' },
    { code: '+49', name: 'Germany' },
    { code: '+971', name: 'UAE' },
    // Add more as needed
];


function MediaManagementPopups() {
    const [VoiceMailunavaliable, setVoiceMailunavaliable] = useState(false);
    const VoiceMailunavaliableToggle = () => setVoiceMailunavaliable(!VoiceMailunavaliable);

    const [VoiceMailunavaliable2, setVoiceMailunavaliable2] = useState(false);
    const VoiceMailunavaliableToggle2 = () => setVoiceMailunavaliable2(!VoiceMailunavaliable2);

    const [VoicemailUnavailableGreeting, setVoicemailUnavailableGreeting] = useState(false);
    const VoicemailUnavailableGreetingToggle = () => setVoicemailUnavailableGreeting(!VoicemailUnavailableGreeting);

    const [HuntGroupPreAnnouncementGreeting, setHuntGroupPreAnnouncementGreeting] = useState(false);
    const HuntGroupPreAnnouncementGreetingToggle = () => setHuntGroupPreAnnouncementGreeting(!HuntGroupPreAnnouncementGreeting);

    const [HuntGroupPreAnnouncementGreeting2, setHuntGroupPreAnnouncementGreeting2] = useState(false);
    const HuntGroupPreAnnouncementGreetingToggle2 = () => setHuntGroupPreAnnouncementGreeting2(!HuntGroupPreAnnouncementGreeting2);

    const [AddLocationWeekly, setAddLocationWeekly] = useState(false);
    const toggleShow22 = () => setAddLocationWeekly(!AddLocationWeekly);

    const [NewSchesule, setNewSchesule] = useState(false)
    const NewSchesuleToggle = () => setNewSchesule(!NewSchesule);


    const prevRef = useRef(null);
    const nextRef = useRef(null);


    const [basicActive, setBasicActive] = useState('tab1');
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const [HuntbasicActive, setHuntBasicActive] = useState('Hunttab1');
    const HunthandleBasicClick = (value) => {
        if (value === HuntbasicActive) {
            return;
        }
        setHuntBasicActive(value);
    };
    const [selectedOption, setSelectedOption] = useState(1); // Default to Personalized

    const handleSelectChange = (event) => {
        setSelectedOption(Number(event.target.value));
    };


    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const defaultData = ['Harish', 'Kowshal', 'Rakesh', 'Ben', 'Chinna', 'Vamsi', 'Naveen', 'Hanisha'];
    const [data, setData] = useState(defaultData);

    const onSearch = (value) => {
        const trimmedValue = value.trim();
        const truncatedValue = trimmedValue.slice(0, 11);

        const isValueInOptions = data.some((item) => item.toLowerCase() === truncatedValue.toLowerCase());

        if (!isValueInOptions) {

            const updatedDefaultData = [...defaultData, truncatedValue];
            setData(updatedDefaultData);

            setData(updatedDefaultData.filter((item) => item.toLowerCase().startsWith(truncatedValue.toLowerCase())));
        } else {

            setData(
                defaultData.filter((item) => item.toLowerCase().startsWith(truncatedValue.toLowerCase()))
            );
        }
    };
    const [selectedOption2, setSelectedOption2] = useState('option1');
    const actionData = {
        columns: [
            { label: 'Name', field: 'name' },
            { label: 'Date and Time Range', field: 'position' },
            { label: 'Remove', field: 'contact', sort: false },
        ],
        rows: [
            {
                name: 'Monday',
                position: 'Monday Fronm 12:00 AM to 2:00 PM',
            },
            {
                name: 'Friday',
                position: 'Monday Fronm 12:00 AM to 2:00 PM',

            },
            {
                name: 'wednsday',
                position: 'Monday Fronm 12:00 AM to 2:00 PM',
            },
        ].map((row) => {
            return {
                ...row,
                contact: (
                    <>
                        <MDBIcon fas icon="times" color="primary" />
                    </>
                ),
            };
        }),
    };
    const actionData2 = {
        columns: [
            { label: 'Name', field: 'name' },
            { label: 'Date and Time Range', field: 'position' },
            { label: 'Remove', field: 'contact', sort: false },
        ],
        rows: [
            {
                name: '4th July',
                position: 'From: 07/04/2023 12:00 AM To: 07/04/2023 11:59 PM',
            },
            {
                name: 'Friday',
                position: 'Monday Fronm 12:00 AM to 2:00 PM',

            },
            {
                name: 'wednsday',
                position: 'Monday Fronm 12:00 AM to 2:00 PM',
            },
        ].map((row) => {
            return {
                ...row,
                contact: (
                    <>
                        <MDBIcon fas icon="times" color="primary" />
                    </>
                ),
            };
        }),
    };






    const [selectValue, setSelectValue] = useState(4);
    const [selectData, setSelectData] = useState([
        { text: 'One', value: 1 },
        { text: 'Two', value: 2 },
        { text: 'Three', value: 3 },
        { text: 'Four', value: 4 },
        { text: 'Five', value: 5 },
    ]);


    const options = ["Option 1", "Option 2", "Option 3"];
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(options[0]);

    useEffect(() => {
        document.addEventListener('click', closeAllSelect);

        return () => {
            document.removeEventListener('click', closeAllSelect);
        };
    }, []);

    const toggleSelect = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOptions(option);
        toggleSelect();
    };

    const closeAllSelect = (event) => {
        // Close the select box if the click is outside the component
        if (!event.target.closest('.custom-select')) {
            setIsOpen(false);
        }
    };


    const items = [
        {
            id: 0,
            name: 'Cobol'
        },
        {
            id: 1,
            name: 'JavaScript'
        },
        {
            id: 2,
            name: 'Basic'
        },
        {
            id: 3,
            name: 'PHP'
        },
        {
            id: 4,
            name: 'Java'
        }
    ]

    const handleOnSearch = (string, results) => {
        console.log(string, results)
    }

    const handleOnHover = (result) => {
        console.log(result)
    }

    const handleOnSelect = (item) => {
        console.log(item)
    }

    const handleOnFocus = () => {
        console.log('Focused')
    }

    const formatResult = (item) => {
        return (
            <>
                <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
            </>
        )
    }


    const [addFilter, setAddFilter] = useState(false);
    const [showSeatPlan, setShowSeatPlan] = useState(false);
    const [showRole, setShowRole] = useState(false);

    const toggleFilter = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setAddFilter(!addFilter)
        setShowRole(false);
        setShowSeatPlan(false);
    };
    const toggleSeatPlan = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setShowSeatPlan(!showSeatPlan);
        setShowRole(false);
    };

    const toggleRole = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setShowRole(!showRole);
        setShowSeatPlan(false);
    };

    const toggleBackClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setShowRole(false);
        setShowSeatPlan(false);
    }
    const [isOpen2, setIsOpen2] = useState(false);

    const [activeRadio, setActiveRadio] = useState('center');

    const handleChange = (e) => {
        setActiveRadio(e.target.value);
        console.log(`${e.target.value} ##################`);
    };




    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const section4 = useRef(null);

    const containerRef = useRef(null);


    const [selectedChips, setSelectedChips] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [message, setMessage] = useState(`Hi, this is a message from [Customer Name], thank you for your business.`);
    const [originalMessage, setOriginalMessage] = useState(message);
    const textareaRef = useRef(null);

    const chips = [
        "2FA",
        "Delivery Notification",
        "Marketing",
        "Public Service Announcement",
        "Account Notification",
        "Fraud Alert Messaging",
        "Machine to Machine",
        "Security Alert",
        "Customer Care",
        "Higher Education",
        "Polling and Voting",
    ];

    const handleChipClick = (chip) => {
        if (selectedChips.includes(chip)) {
            // If chip is already selected, unselect it
            setSelectedChips(selectedChips.filter((item) => item !== chip));
        } else if (selectedChips.length < 5) {
            // Add the chip if not already selected and limit is not reached
            setSelectedChips([...selectedChips, chip]);
        }
        setMessage(`Hi, this is a ${chip} message from [Customer Name], thank you for your business.`);
    };




    const handleEditClick = () => {
        setIsEditing(true);
        setOriginalMessage(message);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setMessage(originalMessage); // Restore original message
    };

    const handleChangeNew = (e) => {
        setMessage(e.target.value);
    };


    const phoneNumbers = Array.from({ length: 1000 }, (_, i) => `800-555-${String(i).padStart(4, "0")}`);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const numbersPerPage = 30;
    const pagesToShow = 5;

    const filteredNumbers = phoneNumbers.filter((num) => num.includes(searchTerm));
    const totalPages = Math.ceil(filteredNumbers.length / numbersPerPage);
    const displayedNumbers = filteredNumbers.slice((currentPage - 1) * numbersPerPage, currentPage * numbersPerPage);

    const toggleSelection = (number) => {
        setSelectedNumbers((prev) =>
            prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
        );
    };

    const getPaginationNumbers = () => {
        let start = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
        let end = Math.min(totalPages, start + pagesToShow - 1);
        if (end - start + 1 < pagesToShow) {
            start = Math.max(1, end - pagesToShow + 1);
        }
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };



    const dummyData = {
        Users: ["Alice", "Bob", "Charlie", "David"],
        "Hunt Groups": ["Support Team", "Sales Team", "Tech Team"],
        "ACD Queues": ["Queue 1", "Queue 2", "Queue 3"],
    };

    const [selectedType, setSelectedType] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    //   const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dropdownRef = useRef();

    // 🧠 Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleMainTypeClick = (type) => {
        setSelectedType(type);
        setSearchTerm("");
    };

    const handleBack = () => {
        setSelectedType(null);
        setSearchTerm("");
    };

    const handleClear = (e) => {
        e.stopPropagation(); // Prevent dropdown from toggling
        setSelectedValue(null);
        setSelectedType(null);
        setSearchTerm("");
        setIsDropdownOpen(true);
    };

    const filteredOptions = selectedType
        ? dummyData[selectedType].filter((item) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];




    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('local');
    const [search, setSearch] = useState('');

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleTabChange = (tab) => {
        if (tab !== activeTab) setActiveTab(tab);
    };

    const phoneNumbersa = [
        { number: '+1 386 232 9226', location: 'Debary, FL' },
        { number: '+1 386 243 2077', location: 'Lake City, FL' },
        { number: '+1 386 243 2260', location: 'Lake City, FL' },
        { number: '+1 386 243 2363', location: 'Lake City, FL' },
        { number: '+1 386 243 2405', location: 'Lake City, FL' },
        { number: '+1 386 243 2478', location: 'Lake City, FL' },
    ];


    const [query, setQuery] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);

    const handleSelect = (country) => {
        setSelectedCountry(country);
        setQuery('');
        setShowDropdown(false);
    };

    const filtered = countries.filter(({ code, name }) =>
        (code + ' ' + name).toLowerCase().includes(query.toLowerCase())
    );

    const [localQuery, setLocalQuery] = useState("");
    const [showLocalDropdown, setShowLocalDropdown] = useState(false);

    // Example numbers for the dropdown
    const localNumbers = [
        "+1 386 243 2730",
        "+1 386 243 2836",
        "+1 386 243 2861",
        "+1 386 243 3076",
        "+1 386 243 3112",
        "+1 386 243 3118",
        // ... more
    ];

    // Filtered results based on search
    const filteredLocalNumbers = localNumbers.filter(num =>
        num.includes(localQuery)
    );


    const localInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (localInputRef.current && !localInputRef.current.contains(event.target)) {
                setShowLocalDropdown(false);
                setShowDropdown(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const AddRemoveButton = () => {
        const [status, setStatus] = useState('initial'); // initial, adding, added, removing
        const [isHovered, setIsHovered] = useState(false);

        const handleAdd = async () => {
            setStatus('adding');
            await new Promise(res => setTimeout(res, 1000)); // simulate API call
            setStatus('added');
        };

        const handleRemove = async () => {
            setStatus('removing');
            await new Promise(res => setTimeout(res, 1000)); // simulate API call
            setStatus('initial');
        };

        const renderText = () => {
            if (status === 'initial') return 'Add';
            if (status === 'adding') return 'Adding...';
            if (status === 'added') return isHovered ? 'Remove' : 'Added';
            if (status === 'removing') return 'Removing...';
        };

        const isDisabled = status === 'adding' || status === 'removing';

        const handleClick = () => {
            if (status === 'initial') handleAdd();
            else if (status === 'added' && isHovered) handleRemove();
        };

        return (
            <MDBBtn
                size='sm'
                onClick={handleClick}
                disabled={isDisabled}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {renderText()}
            </MDBBtn>
        );
    };


    const LocalphoneNumbers = [
        { number: '+1 386 221 4217', location: 'Debary, FL' },
        { number: '+1 386 222 0503', location: 'Palatka, FL' },
        { number: '+1 386 222 0527', location: 'Palatka, FL' },
    ];




    return (
        <React.Fragment>
            <>
                <MainLinks active={3} />
                <Body
                    tablinks={3}
                    sublink={8}
                    content={
                        <section className="userDetails">
                            <div className="card card-height">
                                <div className="card-header py-3 px-0">
                                    <h5 className="mb-0 ">
                                        {t("locations")}
                                    </h5>
                                </div>

                                <div>



                                    <div style={{ minHeight: "80vh" }} className="d-flex flex-column align-items-center justify-content-center">

                                        <MDBBtn onClick={toggleModal}>Order Phone Numbers</MDBBtn>

                                        <MDBModal open={isModalOpen} onClose={toggleModal} size='lg' tabIndex='-1'>
                                            <MDBModalDialog centered size='xxl'>
                                                <MDBModalContent>
                                                    <MDBModalHeader>
                                                        <MDBModalTitle className='w-100 text-center'>Order phone numbers</MDBModalTitle>
                                                    </MDBModalHeader>

                                                    <MDBContainer className='w-60'>
                                                        <MDBModalBody>
                                                            <h3 className='fw-bold'>
                                                                Add phone numbers
                                                            </h3>
                                                            <MDBTabs justify className='mb-3 border-bottom border-2'>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink
                                                                        onClick={() => handleTabChange('local')}
                                                                        active={activeTab === 'local'}
                                                                    >
                                                                        Local numbers
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink
                                                                        onClick={() => handleTabChange('tollfree')}
                                                                        active={activeTab === 'tollfree'}
                                                                    >
                                                                        Toll-free numbers
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                            </MDBTabs>

                                                            <MDBTabsContent>

                                                                <MDBTabsPane open={activeTab === 'local'}>

                                                                    <div className="py-2 px-4 bg-secondary bg-opacity-10 rounded-3 mb-3 d-flex align-items-center gap-2">
                                                                        <MDBIcon fas icon="search" className="text-secondary" />



                                                                        {/* Country/Area Code Selector */}
                                                                        <div className="custom-country-select position-relative flex-grow-1" ref={localInputRef}>
                                                                            <span className="text-secondary position-absolute start-0 top-50 translate-middle-y ps-2 " style={{ zIndex: 9 }}>+1 &#40;</span>

                                                                            <input
                                                                                type="text"
                                                                                className="form-control border-0 bg-transparent"
                                                                                placeholder="Area Code"
                                                                                value={query}
                                                                                onChange={(e) => {
                                                                                    setQuery(e.target.value);
                                                                                    setShowDropdown(true);
                                                                                }}
                                                                                onClick={() => setShowDropdown(true)}
                                                                            />
                                                                            <span className="text-secondary position-absolute end-0 top-50 translate-middle-y pe-2">&#41;</span>

                                                                            {showDropdown && filtered.length > 0 && (
                                                                                <ul className="dropdown-menu show w-100 shadow-sm mt-1">
                                                                                    {filtered.map((country, index) => (
                                                                                        <li key={index} onClick={() => handleSelect(country)} className="dropdown-item">
                                                                                            <span className="fw-bold d-block">{country.code}</span>
                                                                                            <small className="text-secondary d-inline-block">{country.name}</small>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            )}
                                                                        </div>

                                                                        {/* Additional Input (if needed) */}
                                                                        <div className="position-relative w-100  custom-add-phone-select" ref={localInputRef}>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control flex-grow-1 border-0 bg-transparent"
                                                                                placeholder="Search Local Number"
                                                                                value={localQuery}
                                                                                onChange={(e) => {
                                                                                    setLocalQuery(e.target.value);
                                                                                    setShowLocalDropdown(true);
                                                                                }}
                                                                                onClick={() => setShowLocalDropdown(true)}
                                                                            />

                                                                            {showLocalDropdown && filteredLocalNumbers.length > 0 && (
                                                                                <ul className="dropdown-menu phone-number-menu show w-100 shadow-5 mt-1">
                                                                                    {filteredLocalNumbers.map((number, index) => (
                                                                                        <li
                                                                                            key={index}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                e.preventDefault();
                                                                                                setLocalQuery(number);
                                                                                                setShowLocalDropdown(false);
                                                                                            }}
                                                                                            className="dropdown-item d-flex align-items-center justify-content-between"
                                                                                        >
                                                                                            <div>
                                                                                                <span className="fw-bold d-block hover-white">{number}</span>
                                                                                                <small className="text-secondary">Lake City, FL</small>
                                                                                            </div>

                                                                                            <AddRemoveButton />
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            )}
                                                                        </div>

                                                                    </div>

                                                                    <MDBBtn color='secondary' className='mb-3 float-end' onClick={() => console.log("Advanced Search")}>
                                                                        Advanced search
                                                                    </MDBBtn>

                                                                    <MDBCard className='w-100 shadow-0'>
                                                                        <MDBCardBody>
                                                                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                                <h5 className='mb-0'>Your numbers</h5>
                                                                                <small className='text-muted'>Numbers are reserved for 4 hours</small>
                                                                            </div>

                                                                            <div className='d-flex align-items-start gap-2'>
                                                                                <MDBCheckbox />

                                                                                <div>
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <span>3 number(s)</span>
                                                                                    </div>
                                                                                </div>

                                                                                <MDBIcon far icon='trash-alt' role='button' className='text-primary' />
                                                                            </div>

                                                                            <MDBListGroup flush>
                                                                                {LocalphoneNumbers.map((item, index) => (
                                                                                    <MDBListGroupItem
                                                                                        key={index}
                                                                                        className='d-flex align-items-center justify-content-between'
                                                                                    >
                                                                                        <div className='d-flex align-items-start gap-2'>
                                                                                            <MDBCheckbox />

                                                                                            <div>
                                                                                                <div className='d-flex align-items-center gap-2'>
                                                                                                    <span>{item.number}</span>
                                                                                                    <MDBBadge color='secondary' pill>
                                                                                                        Local
                                                                                                    </MDBBadge>
                                                                                                </div>
                                                                                                <div className='text-muted' style={{ fontSize: '0.9rem' }}>
                                                                                                    {item.location}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <MDBIcon far icon='trash-alt' role='button' className='text-primary' />
                                                                                    </MDBListGroupItem>
                                                                                ))}
                                                                            </MDBListGroup>
                                                                        </MDBCardBody>
                                                                    </MDBCard>



                                                                </MDBTabsPane>

                                                                <MDBTabsPane open={activeTab === 'tollfree'}>
                                                                    <p>No toll-free numbers available.</p>
                                                                </MDBTabsPane>
                                                            </MDBTabsContent>
                                                        </MDBModalBody>
                                                    </MDBContainer>
                                                    <MDBModalFooter>
                                                        <MDBBtn color='secondary' onClick={toggleModal}>
                                                            Close
                                                        </MDBBtn>
                                                        <MDBBtn color='primary' onClick={() => console.log("Order Numbers")}>
                                                            Next
                                                        </MDBBtn>
                                                    </MDBModalFooter>
                                                </MDBModalContent>
                                            </MDBModalDialog>
                                        </MDBModal>

                                    </div>









                                    <div style={{ minHeight: "100vh" }}>


                                        <div className="add-numbermain w-70">
                                            <div>Add Numbers</div>
                                            <div>

                                                <div className="custom-selector" ref={dropdownRef}>
                                                    <div
                                                        className="custom-selector-box form-select"
                                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                    >
                                                        {selectedValue || "Select Option"}
                                                        {selectedValue && isDropdownOpen && (
                                                            <MDBIcon fas icon="times" className="clear-btn" onClick={handleClear} />
                                                        )}
                                                    </div>

                                                    {isDropdownOpen && (
                                                        <div className="custom-selector-dropdown">
                                                            {!selectedType ? (
                                                                <div className="custom-selector-options">
                                                                    {Object.keys(dummyData).map((type) => (
                                                                        <div
                                                                            key={type}
                                                                            className="custom-selector-option"
                                                                            onClick={() => handleMainTypeClick(type)}
                                                                        >
                                                                            {type}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <div className="custom-selector-suboptions">
                                                                    <div className="top-bar">
                                                                        <input
                                                                            type="text"
                                                                            placeholder={`Search ${selectedType}`}
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                                        />
                                                                        {searchTerm && (
                                                                            <MDBIcon fas icon="times" className="px-2" color='danger' onClick={() => setSearchTerm("")} />
                                                                        )}
                                                                    </div>
                                                                    <div className="suboptions-list">
                                                                        {filteredOptions.length > 0 ? (
                                                                            filteredOptions.map((item) => (
                                                                                <div
                                                                                    key={item}
                                                                                    className="custom-selector-option"
                                                                                    onClick={() => {
                                                                                        setSelectedValue(item);
                                                                                        setIsDropdownOpen(false);
                                                                                    }}
                                                                                >
                                                                                    {item}
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <div className="custom-selector-option">No results found</div>
                                                                        )}
                                                                    </div>
                                                                    <MDBModalFooter className="py-2 pe-2">
                                                                        <MDBBtn size='sm' className="back-btn" onClick={handleBack}>
                                                                            Back
                                                                        </MDBBtn>
                                                                    </MDBModalFooter>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>




                                        <div className="d-flex align-items-start">

                                            <div className="seq-bg">
                                                <div className="d-flex align-items-center justify-content-between p-2">
                                                    <h5 className='m-0'>Sequence 1</h5>
                                                    <div className="d-flex">
                                                        <button className='seq-header-btn me-2'>
                                                            <MDBIcon fas icon="plus" color='primary' size='lg' />
                                                        </button>
                                                        {/* <button className='seq-header-btn'>
                                                            <MDBIcon fas icon="ellipsis-v" color='primary' size='lg' />
                                                        </button> */}

                                                        <MDBDropdown>
                                                            <MDBDropdownToggle tag='button' className='seq-header-btn  border-0 shadow-0'>
                                                                <MDBIcon fas icon='ellipsis-v' color='primary' size='lg' />
                                                            </MDBDropdownToggle>
                                                            <MDBDropdownMenu>
                                                                <MDBDropdownItem link onClick={() => console.log("Insert cloned Sequence")}>
                                                                    Insert cloned Sequence
                                                                </MDBDropdownItem>
                                                                <MDBDropdownItem link onClick={() => console.log("Clone and move to end")}>
                                                                    Clone sequence and move to the end
                                                                </MDBDropdownItem>
                                                                <MDBDropdownItem link className='text-danger' onClick={() => console.log("Delete sequence")}>
                                                                    Delete Sequence
                                                                </MDBDropdownItem>
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>

                                                    </div>
                                                </div>

                                                <MDBCard className='mt-2 p-0 rounded-3'>
                                                    <MDBCardBody className='p-2 rounded-3 pt-3'>
                                                        <div className="position-relative">
                                                            <MDBInput label='Ring Time' id='form1' type='text' value={20} />
                                                            <span class="seconds ">Seconds</span>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis' title='Mobile Softphone'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        Mobile Softphone
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' />
                                                                        <label htmlFor="inlineCheckbox1" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>


                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 2
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 1
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <div className="d-flex align-items-center">
                                                                            <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                            <div>
                                                                                <p className='text-primary fw-500 m-0 seq-name_ellipsis lh-normal'>
                                                                                    Custom Device
                                                                                </p>
                                                                                <small className='fw-500'>9848173866</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <label htmlFor="inlineCheckbox4" className='cursor-pointer fw-500'>Caller ID Pass Through</label>
                                                                <MDBCheckbox name='inlineCheck' id='inlineCheckbox4' value='option1' className='ms-2' />

                                                            </div>

                                                            <select name="" id="" className='form-select' placeholder='Caller ID Pass Through'>
                                                                <option value="">Choose Caller ID...</option><option value="volvo">Volvo</option>
                                                            </select>



                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>


                                                    </MDBCardBody>
                                                </MDBCard>

                                            </div>

                                            <div className='arrow-container'>
                                                <img src={SeqArrow} alt="" className='seq-arrow' />

                                                <div className="bouncing-dot">
                                                    <button class="seq-button">
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="seq-bg">
                                                <div className="d-flex align-items-center justify-content-between p-2">
                                                    <h5 className='m-0'>Sequence 1</h5>
                                                    <div className="d-flex">
                                                        <button className='seq-header-btn me-2'>
                                                            <MDBIcon fas icon="plus" color='primary' size='lg' />
                                                        </button>
                                                        <button className='seq-header-btn'>
                                                            <MDBIcon fas icon="ellipsis-v" color='primary' size='lg' />
                                                        </button>
                                                    </div>
                                                </div>

                                                <MDBCard className='mt-2 p-0 rounded-3'>
                                                    <MDBCardBody className='p-2 rounded-3 pt-3'>
                                                        <div className="position-relative">
                                                            <MDBInput label='Ring Time' id='form1' type='text' value={20} />
                                                            <span class="seconds ">Seconds</span>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis' title='Mobile Softphone'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        Mobile Softphone
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' />
                                                                        <label htmlFor="inlineCheckbox1" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>


                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 2
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 1
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>



                                                    </MDBCardBody>
                                                </MDBCard>

                                            </div>


                                            <div className='arrow-container'>
                                                <img src={SeqArrow} alt="" className='seq-arrow' />

                                                <div className="bouncing-dot">
                                                    <button class="seq-button">
                                                    </button>
                                                </div>
                                            </div>


                                            <div className="seq-bg">
                                                <div className="d-flex align-items-center justify-content-between p-2">
                                                    <h5 className='m-0'>Sequence 1</h5>
                                                    <div className="d-flex">
                                                        <button className='seq-header-btn me-2'>
                                                            <MDBIcon fas icon="plus" color='primary' size='lg' />
                                                        </button>
                                                        <button className='seq-header-btn'>
                                                            <MDBIcon fas icon="ellipsis-v" color='primary' size='lg' />
                                                        </button>
                                                    </div>
                                                </div>

                                                <MDBCard className='mt-2 p-0 rounded-3'>
                                                    <MDBCardBody className='p-2 rounded-3 pt-3'>
                                                        <div className="position-relative">
                                                            <MDBInput label='Ring Time' id='form1' type='text' value={20} />
                                                            <span class="seconds ">Seconds</span>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis' title='Mobile Softphone'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        Mobile Softphone
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' />
                                                                        <label htmlFor="inlineCheckbox1" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>


                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 2
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 1
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>



                                                    </MDBCardBody>
                                                </MDBCard>

                                            </div>


                                            <div className='arrow-container'>
                                                <img src={SeqArrow} alt="" className='seq-arrow' />

                                                <div className="bouncing-dot">
                                                    <button class="seq-button">
                                                    </button>
                                                </div>
                                            </div>


                                            <div className="seq-bg">
                                                <div className="d-flex align-items-center justify-content-between p-2">
                                                    <h5 className='m-0'>Sequence 1</h5>
                                                    <div className="d-flex">
                                                        <button className='seq-header-btn me-2'>
                                                            <MDBIcon fas icon="plus" color='primary' size='lg' />
                                                        </button>
                                                        <button className='seq-header-btn'>
                                                            <MDBIcon fas icon="ellipsis-v" color='primary' size='lg' />
                                                        </button>
                                                    </div>
                                                </div>

                                                <MDBCard className='mt-2 p-0 rounded-3'>
                                                    <MDBCardBody className='p-2 rounded-3 pt-3'>
                                                        <div className="position-relative">
                                                            <MDBInput label='Ring Time' id='form1' type='text' value={20} />
                                                            <span class="seconds ">Seconds</span>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis' title='Mobile Softphone'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        Mobile Softphone
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' />
                                                                        <label htmlFor="inlineCheckbox1" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>


                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 2
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>

                                                        <div className="border-bottom border border-dashed my-3" />


                                                        <div>
                                                            <div className='mt-3 mb-2'>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <p className='text-primary fw-500 seq-name_ellipsis'>
                                                                        <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                                                                        IP Phone 1
                                                                    </p>
                                                                    <div className="d-flex align-items-center">
                                                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                                                                        <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                                                                        <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                                                                            <MDBIcon fas icon="times" color='danger' size='md' />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <MDBInputGroup className='mt-2'>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='From' inline />
                                                                </div>
                                                                <div style={{ width: "50%" }}>
                                                                    <MDBTimepicker inputLabel='To' inline />
                                                                </div>
                                                            </MDBInputGroup>
                                                        </div>



                                                    </MDBCardBody>
                                                </MDBCard>

                                            </div>

                                            <div className='arrow-container'>
                                                <img src={SeqArrow} alt="" className='seq-arrow' />

                                                <div className="bouncing-dot">
                                                    <button class="seq-button">
                                                    </button>
                                                </div>
                                            </div>



                                            {/* 
                                            <div className="seq-bg seq-vm-bg">
                                                <div className="d-flex align-items-center justify-content-between p-2">
                                                    <h6 className='m-0'>Voice Mail</h6>

                                                </div>

                                                <MDBCard className='mt-2 p-0 rounded-3'>
                                                    <MDBCardBody className='p-2 rounded-3 pt-3'>
                                                        <div className="d-flex justify-content-center w-100">
                                                            <CustomAudioPlayer />
                                                        </div>

                                                    </MDBCardBody>
                                                </MDBCard>

                                            </div> */}



                                        </div>
















                                    </div>















                                    <div className="d-flex">
                                        <div>
                                            <MDBBtn onClick={VoiceMailunavaliableToggle} className="me-2"> {t("VoiceMailunavaliableGreeting")}</MDBBtn>
                                            <MDBModal open={VoiceMailunavaliable} setOpen={setVoiceMailunavaliable} tabIndex='-1'>
                                                <MDBModalDialog centered size='fullscreen'>
                                                    <MDBModalContent>
                                                        <MDBModalHeader>
                                                            <MDBModalTitle>SMS Compliance</MDBModalTitle>
                                                            <MDBBtn className='btn-close' color='none' onClick={VoiceMailunavaliableToggle}></MDBBtn>
                                                        </MDBModalHeader>
                                                        <MDBModalBody>
                                                            <MDBContainer>
                                                                <MDBScrollspy container={containerRef}>
                                                                    <div className="d-flex ">
                                                                        <MDBScrollspyLink targetRef={section1}>Start Business Registration</MDBScrollspyLink>
                                                                        <MDBScrollspyLink targetRef={section2}>SMS Campaign Details</MDBScrollspyLink>
                                                                        <MDBScrollspyLink targetRef={section3}>Phone Numbers and Fees</MDBScrollspyLink>
                                                                        <MDBScrollspyLink targetRef={section4}>Confirm and Submit</MDBScrollspyLink>
                                                                    </div>
                                                                </MDBScrollspy>



                                                                <div id='element' ref={containerRef} className='scrollspy-example w-100 m-0 p-0'>
                                                                    <section ref={section1} id='section-1'>
                                                                        <h3>Start Business Registration</h3>
                                                                        <div class="note note-info">
                                                                            <h5 className='fw-bold'>
                                                                                SMS Compliance:
                                                                            </h5>

                                                                            <p>The Campaign Registry (TCR) will review the website used during registartion for certain criteria. If your website is not compliant, your registrations may be rejected, leading to additional fees. Before you start check that your website</p>
                                                                            <ul>
                                                                                <li>Is fully functional and appropriately age-gated if needed.</li>
                                                                                <li>Contains opt-in messaging that tells subscribers how their number will be used.</li>
                                                                                <li>Contains a compliant and easily-accessible privacy policy and SMS Disclaimer.</li>
                                                                                <li>Tip: Make sure that all data collection forms on your website contain a link to your privacy policy.</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="mt-4">
                                                                            <h5 className='fw-bold'>
                                                                                Business Registration
                                                                            </h5>

                                                                            <MDBRow>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Business Contact Name</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Email Address:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Phone Number:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Legal Company Name:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>DBA Name:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>EIN/Tax Number:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>EIN/Tax Number Issuing Country:</strong></div>
                                                                                    <select className='form-select' required>
                                                                                        <option value="USA">USA</option>
                                                                                        <option value="Canada">Canada</option>
                                                                                    </select>
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Legal Formation of Business:</strong></div>
                                                                                    <select className='form-select' required>
                                                                                        <option value="public">Publicly traded Company</option>
                                                                                        <option value="preivate">Private Company</option>
                                                                                        <option value="nonprofit">Non-Profit Organization</option>
                                                                                        <option value="government">Government</option>
                                                                                    </select>
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Industry Vertical:</strong></div>
                                                                                    <select className='form-select' required>
                                                                                        <option value="agriculture">Agriculture</option>
                                                                                        <option value="mediacomm">Media and Communication</option>
                                                                                        <option value="construction">Construction,Materials and Trade Services</option>
                                                                                        <option value="education">Education</option>
                                                                                        <option value="energy">Energy and Utilities</option>
                                                                                        <option value="dntertainment">Entertainment</option>
                                                                                        <option value="financial">Financial Services</option>
                                                                                        <option value="lottery">Gambling and Lottery</option>
                                                                                        <option value="government">Government Services and Agencies</option>
                                                                                        <option value="healthcare">Healthcare and Life Sciences</option>
                                                                                        <option value="travel">Hospitality and Travel</option>
                                                                                        <option value="hr">HR, Staffing, or Recruitment</option>
                                                                                        <option value="insurance">Insurance</option>
                                                                                        <option value="legal">Legal</option>
                                                                                        <option value="manufacturing">Manufacturing</option>
                                                                                        <option value="nonprofit">Non-profit Organization</option>
                                                                                        <option value="political">Political</option>
                                                                                        <option value="postaldelivery">Postal and Delivery</option>
                                                                                        <option value="professionalsrv">Professional Services</option>
                                                                                        <option value="realestate">Real Estate</option>
                                                                                        <option value="retail">Retail and Consumer Products</option>
                                                                                        <option value="itsrv">Information Technology Services</option>
                                                                                        <option value="logistics">Transportation or Logistics</option>
                                                                                    </select>
                                                                                </MDBCol>
                                                                                <MDBCol sm={12} md={6} lg={6} xl={6} className='mb-4'>

                                                                                    <div class="tel-numbers"><strong>Business Website / Online Presence:</strong></div>
                                                                                    <MDBInput />
                                                                                </MDBCol>
                                                                            </MDBRow>
                                                                        </div>



                                                                    </section>
                                                                    <div className="routing-border p-0 mb-5"></div>
                                                                    <section ref={section2} id='section-2'>
                                                                        <h3>SMS Campaign Details</h3>
                                                                        <div className="mt-4">
                                                                            <div class="tel-numbers"><strong>Campaign Name:</strong></div>
                                                                            <MDBInput />
                                                                        </div>
                                                                        <div className="mt-3">
                                                                            <div className="tel-numbers">
                                                                                <strong>Use Case: Select a minimum of 1 and a maximum of 5</strong>
                                                                            </div>
                                                                            <div className="d-flex flex-wrap mt-3">
                                                                                {chips.map((chip) => {
                                                                                    const isActive = selectedChips.includes(chip);
                                                                                    const isDisabled = selectedChips.length >= 5 && !isActive;

                                                                                    return (
                                                                                        <div className={isDisabled ? "cursor-notallowed" : ""}>
                                                                                            <div
                                                                                                key={chip}
                                                                                                className={`chip ${isActive ? "active" : ""} ${isDisabled ? "bg-danger text-light pointer-events-none" : ""
                                                                                                    }`}
                                                                                                onClick={() => !isDisabled && handleChipClick(chip)}
                                                                                            >
                                                                                                {chip}
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>

                                                                            <div className="selected-content my-4">
                                                                                {selectedChips.length > 0 && (
                                                                                    selectedChips.map((chip, index) => (
                                                                                        <>
                                                                                            <div className='border p-3 rounded-4 mb-4' key={index}>
                                                                                                <div className="tel-numbers mb-2">
                                                                                                    <strong>Sample Message for: {chip} (minimum 20 characters)</strong>
                                                                                                    <span className="ms-2 cursor-pointer">
                                                                                                        {isEditing ? (
                                                                                                            <>
                                                                                                                <MDBIcon onClick={handleSaveClick} fas icon="save" size='lg' />
                                                                                                                <MDBIcon onClick={handleCancelClick} fas icon="times" size='lg' className='ms-3' />

                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <MDBIcon
                                                                                                                fas
                                                                                                                icon="pencil-alt"
                                                                                                                size="lg"
                                                                                                                onClick={handleEditClick}
                                                                                                            />
                                                                                                        )}
                                                                                                    </span>
                                                                                                    <MDBTextArea
                                                                                                        ref={textareaRef}
                                                                                                        value={message}
                                                                                                        rows={4}
                                                                                                        onChange={handleChangeNew}
                                                                                                        readOnly={!isEditing}
                                                                                                    />
                                                                                                </div>

                                                                                                <MDBRow>
                                                                                                    <MDBCol sm={12} md={4} lg={4}>
                                                                                                        <div className="add-numbermain">
                                                                                                            <div class="tel-numbers">Embedded Link</div>

                                                                                                            <div className="phoneselect ">
                                                                                                                <label className="switch">
                                                                                                                    <input className="form-control" type="checkbox" />
                                                                                                                    <span className="slider round"></span>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </MDBCol>
                                                                                                    <MDBCol sm={12} md={4} lg={4}>
                                                                                                        <div className="add-numbermain">
                                                                                                            <div class="tel-numbers">Embedded Phone Number</div>

                                                                                                            <div className="phoneselect ">
                                                                                                                <label className="switch">
                                                                                                                    <input className="form-control" type="checkbox" />
                                                                                                                    <span className="slider round"></span>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </MDBCol>
                                                                                                    <MDBCol sm={12} md={4} lg={4}>
                                                                                                        <div className="add-numbermain">
                                                                                                            <div class="tel-numbers">Age-Gated Content</div>

                                                                                                            <div className="phoneselect ">
                                                                                                                <label className="switch">
                                                                                                                    <input className="form-control" type="checkbox" />
                                                                                                                    <span className="slider round"></span>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </MDBCol>
                                                                                                </MDBRow>
                                                                                            </div>
                                                                                        </>
                                                                                    ))
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                    <section ref={section3} id='section-3'>
                                                                        <h3>Phone Numbers and Fees</h3>
                                                                        <h5 className="fw-bold">Select Phone Numbers and Review Pricing</h5>

                                                                        <MDBInput
                                                                            placeholder="Search Phone Numbers"
                                                                            value={searchTerm}
                                                                            onChange={(e) => {
                                                                                setSearchTerm(e.target.value);
                                                                                setCurrentPage(1);
                                                                            }}
                                                                        />

                                                                        <p className=' mt-4 mb-2'>
                                                                            You can select up to {phoneNumbers.length} phone numbers.
                                                                        </p>
                                                                        <div className="d-flex flex-wrap">

                                                                            {displayedNumbers.map((num) => (
                                                                                <MDBChip
                                                                                    key={num}
                                                                                    className={selectedNumbers.includes(num) ? "active" : ""}
                                                                                    onClick={() => toggleSelection(num)}
                                                                                >
                                                                                    {num}
                                                                                </MDBChip>
                                                                            ))}
                                                                        </div>

                                                                        <nav aria-label="pagination" className="mt-4 d-flex justify-content-center">
                                                                            <MDBPagination>
                                                                                <MDBPaginationItem disabled={currentPage === 1}>
                                                                                    <MDBPaginationLink href="#" onClick={() => setCurrentPage(currentPage - 1)}>Previous</MDBPaginationLink>
                                                                                </MDBPaginationItem>
                                                                                {getPaginationNumbers().map((page) => (
                                                                                    <MDBPaginationItem key={page} active={currentPage === page}>
                                                                                        <MDBPaginationLink href="#" onClick={() => setCurrentPage(page)}>{page}</MDBPaginationLink>
                                                                                    </MDBPaginationItem>
                                                                                ))}
                                                                                <MDBPaginationItem disabled={currentPage === totalPages}>
                                                                                    <MDBPaginationLink href="#" onClick={() => setCurrentPage(currentPage + 1)}>Next</MDBPaginationLink>
                                                                                </MDBPaginationItem>
                                                                            </MDBPagination>
                                                                        </nav>

                                                                        <div class="tel-numbers"><strong>Estimated Monthly Message Volume:</strong></div>
                                                                        <select className='form-select' required>
                                                                            <option value="agriculture">Low Useage</option>
                                                                            <option value="mediacomm">Standard Useage</option>
                                                                        </select>



                                                                        <div class="tel-numbers mt-3"><strong>Pricing Details</strong></div>

                                                                        <h5 className="fw-bold">
                                                                            All plans require a 3-month commitment.
                                                                        </h5>


                                                                        <MDBTable bordered>
                                                                            <MDBTableHead>
                                                                                <tr>
                                                                                    <th>Plan</th>
                                                                                    <th>Details</th>
                                                                                    <th>Cost</th>
                                                                                </tr>
                                                                            </MDBTableHead>
                                                                            <MDBTableBody>
                                                                                <tr>
                                                                                    <td>One-Time Registration (NRC)</td>
                                                                                    <td>Required for all campaigns</td>
                                                                                    <td>$19</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Low Volume Campaign</td>
                                                                                    <td>
                                                                                        <ul>
                                                                                            <li>Max 6,000 messages/month</li>
                                                                                            <li>Max 2,000 messages/day</li>
                                                                                            <li>Max 75 messages/minute</li>
                                                                                        </ul>
                                                                                    </td>
                                                                                    <td>$1.50/month</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Standard Campaign</td>
                                                                                    <td>For campaigns exceeding Low Volume limits</td>
                                                                                    <td>$10/month</td>
                                                                                </tr>
                                                                            </MDBTableBody>
                                                                        </MDBTable>



                                                                    </section>
                                                                    <section ref={section4} id='section-4'>
                                                                        <h3>Section 4</h3>
                                                                        <p>
                                                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore earum natus vel minima quod error
                                                                            maxime, molestias ut. Fuga dignissimos nisi nemo necessitatibus quisquam obcaecati et reiciendis
                                                                            quaerat accusamus numquam.
                                                                        </p>
                                                                        <p>
                                                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore earum natus vel minima quod error
                                                                            maxime, molestias ut. Fuga dignissimos nisi nemo necessitatibus quisquam obcaecati et reiciendis
                                                                            quaerat accusamus numquam.
                                                                        </p>
                                                                    </section>
                                                                </div>





                                                            </MDBContainer>
                                                        </MDBModalBody>

                                                        <MDBModalFooter>
                                                            <MDBBtn color='secondary' onClick={VoiceMailunavaliableToggle}>
                                                                Cancle
                                                            </MDBBtn>
                                                            <MDBBtn>Done</MDBBtn>
                                                        </MDBModalFooter>
                                                    </MDBModalContent>
                                                </MDBModalDialog>
                                            </MDBModal>
                                        </div>
                                        <div>
                                            <MDBBtn className="me-2" onClick={HuntGroupPreAnnouncementGreetingToggle}> {t("HuntGroupPreAnnouncementGreeting")}</MDBBtn>

                                            <MDBModal open={HuntGroupPreAnnouncementGreeting} setShow={setHuntGroupPreAnnouncementGreeting} tabIndex='-1'>
                                                <MDBModalDialog centered>
                                                    <MDBModalContent>
                                                        <MDBModalHeader>
                                                            <MDBModalTitle> {t("HuntGroupPreAnnouncementGreeting")}</MDBModalTitle>
                                                            <MDBBtn className='btn-close' color='none' onClick={HuntGroupPreAnnouncementGreetingToggle}></MDBBtn>
                                                        </MDBModalHeader>
                                                        <MDBModalBody>

                                                            <div className="add-numbermain align-items-baseline">
                                                                <div>
                                                                    <div className="fw-500">
                                                                        {t("GreetingType")}
                                                                    </div>
                                                                    <span className="phrecording">
                                                                        {t("DefaultPersonalizedGreeting")}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <MDBSelect
                                                                        className="w-100"
                                                                        data={[
                                                                            { text: "Personalized", value: 1 },
                                                                            { text: "Two", value: 2 },
                                                                            { text: "Three", value: 3 },
                                                                            { text: "Four", value: 4 },
                                                                            { text: "Five", value: 5 },
                                                                            { text: "Six", value: 6 },
                                                                            { text: "Seven", value: 7 },
                                                                            { text: "Eight", value: 8 },
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="routing-border m-0 pt-1 mb-2"></div>

                                                            <MDBTabs className='mb-3 d-flex justify-content-center'>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab1')} active={HuntbasicActive === 'Hunttab1'}>
                                                                        {t("mediaLibrary")}
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab2')} active={HuntbasicActive === 'Hunttab2'}>
                                                                        {t("upload")}
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab3')} active={HuntbasicActive === 'Hunttab3'}>
                                                                        {t("recordonMic")}
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                                <MDBTabsItem>
                                                                    <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab4')} active={HuntbasicActive === 'Hunttab4'}>
                                                                        {t("recordonPhone")}
                                                                    </MDBTabsLink>
                                                                </MDBTabsItem>
                                                            </MDBTabs>

                                                            <MDBTabsContent>
                                                                <MDBTabsPane open={HuntbasicActive === 'Hunttab1'}>
                                                                    {/* Tab 1 content */}
                                                                    <div className="d-flex justify-content-center huntGreetSelect">
                                                                        <MDBSelect
                                                                            className="w-100"
                                                                            data={[
                                                                                { text: 'Search', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </MDBTabsPane>
                                                                <MDBTabsPane open={HuntbasicActive === 'Hunttab2'}>
                                                                    {/* Tab 2 content */}

                                                                    <MDBContainer className="d-flex flex-column align-items-center justify-content-center">

                                                                        <MDBInput label="Enter a Name" className="w-100" />

                                                                        <span className="text-danger">
                                                                            Required
                                                                        </span>

                                                                        <div className="mt-3">
                                                                            {/* <MDBFile id="customFile" />
                                                                        <span className="phrecording">
                                                                            {t("maxuploadsize")}
                                                                        </span> */}

                                                                            <div className="d-flex align-items-center">

                                                                                <audio controls className="mt-3" />

                                                                                <MDBBtn className="mt-3 ms-3" >
                                                                                    upload<MDBIcon fas icon="upload" className="ms-2" />
                                                                                </MDBBtn>
                                                                            </div>
                                                                        </div>
                                                                    </MDBContainer>
                                                                </MDBTabsPane>
                                                                <MDBTabsPane open={HuntbasicActive === 'Hunttab3'}>
                                                                    {/* Tab 3 content */}
                                                                    <MDBInput label="Enter a Name" className="w-100" />

                                                                    <span className="text-danger">
                                                                        Required
                                                                    </span>

                                                                    <div className="d-flex align-items-center justify-content-center py-3">

                                                                        <div className="voice-recording">
                                                                            <div className="recorging-box ms-4"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box"></div>
                                                                            <div className="recorging-box me-4"></div>
                                                                        </div>
                                                                        <div className="recording-dot mx-5"></div>
                                                                        {/* <div className="recording-dotstop ms-5"></div> */}
                                                                        <MDBBtn >
                                                                            upload<MDBIcon fas icon="upload" className="ms-2" />
                                                                        </MDBBtn>

                                                                    </div>


                                                                </MDBTabsPane>
                                                                <MDBTabsPane open={HuntbasicActive === 'Hunttab4'}>
                                                                    {/* Tab 4 content */}
                                                                    <div className="d-flex flex-column justify-content-center align-items-center w-100">

                                                                        <div className="d-flex align-items-center justify-content-center w-80">
                                                                            <MDBInput label='Where To Call' id='form1' type='text' />
                                                                            <MDBBtn className="ms-4">Call</MDBBtn>
                                                                            <MDBBtn color="danger" className="ms-4 W-100">End Call</MDBBtn>
                                                                        </div>
                                                                        <p className="text-secondary mt-3">Connected</p>
                                                                        <p className="text-danger mt-3">The recording was not successful</p>
                                                                        {/* <p className="text-primary mt-3">Your Personalized Greeting is Now Activated</p> */}
                                                                    </div>


                                                                </MDBTabsPane>
                                                            </MDBTabsContent>
                                                        </MDBModalBody>

                                                        <MDBModalFooter>
                                                            <MDBBtn color='secondary' onClick={VoiceMailunavaliableToggle}>
                                                                Close
                                                            </MDBBtn>
                                                            <MDBBtn>Save changes</MDBBtn>
                                                        </MDBModalFooter>
                                                    </MDBModalContent>
                                                </MDBModalDialog>
                                            </MDBModal>

                                        </div>
                                        <div>
                                            <MDBBtn onClick={HuntGroupPreAnnouncementGreetingToggle2} className="me-2"> {t("HuntGroupPreAnnouncementGreeting")}</MDBBtn>

                                            <MDBModal open={HuntGroupPreAnnouncementGreeting2} setShow={setHuntGroupPreAnnouncementGreeting2} tabIndex='-1'>
                                                <MDBModalDialog centered>
                                                    <MDBModalContent>
                                                        <MDBModalHeader>
                                                            <MDBModalTitle> {t("HuntGroupPreAnnouncementGreeting")}</MDBModalTitle>
                                                            <MDBBtn className='btn-close' color='none' onClick={HuntGroupPreAnnouncementGreetingToggle2}></MDBBtn>
                                                        </MDBModalHeader>
                                                        <MDBModalBody>

                                                            <div className="add-numbermain align-items-baseline">
                                                                <div>
                                                                    <div className="fw-500">
                                                                        {t("GreetingType")}
                                                                    </div>
                                                                    <span className="phrecording">
                                                                        {t("DefaultPersonalizedGreeting")}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <MDBSelect
                                                                        className="w-100"
                                                                        data={[
                                                                            { text: "Personalized", value: 1 },
                                                                            { text: "Two", value: 2 },
                                                                            { text: "Three", value: 3 },
                                                                            { text: "Four", value: 4 },
                                                                            { text: "Five", value: 5 },
                                                                            { text: "Six", value: 6 },
                                                                            { text: "Seven", value: 7 },
                                                                            { text: "Eight", value: 8 },
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="routing-border m-0 pt-1 mb-2"></div>
                                                            <p className="text-secondary phrecording mt-3">
                                                                {t("ListenCurrentGreetingmsg")}
                                                            </p>

                                                            <div className="d-flex align-items-center justify-content-center">

                                                                <audio controls className="mt-3" /><strong className="mt-3 ms-3">Edit</strong>
                                                            </div>


                                                        </MDBModalBody>

                                                        <MDBModalFooter>
                                                            <MDBBtn color='secondary' onClick={VoiceMailunavaliableToggle}>
                                                                Cancle
                                                            </MDBBtn>
                                                            <MDBBtn>Done</MDBBtn>
                                                        </MDBModalFooter>
                                                    </MDBModalContent>
                                                </MDBModalDialog>
                                            </MDBModal>

                                        </div>
                                        <div>
                                            <MDBBtn onClick={VoiceMailunavaliableToggle2} className="me-2"> {t("VoiceMailunavaliableGreeting2")}</MDBBtn>

                                            <MDBModal open={VoiceMailunavaliable2} setShow={setVoiceMailunavaliable2} tabIndex='-1'>
                                                <MDBModalDialog centered>
                                                    <MDBModalContent>
                                                        <MDBModalHeader>
                                                            <MDBModalTitle> {t("VoiceMailunavaliableGreeting")}</MDBModalTitle>
                                                            <MDBBtn className='btn-close' color='none' onClick={VoiceMailunavaliableToggle2}></MDBBtn>
                                                        </MDBModalHeader>
                                                        <MDBModalBody>

                                                            <div className="add-numbermain align-items-baseline">
                                                                <div>
                                                                    <div className="fw-500">
                                                                        {t("GreetingType")}
                                                                    </div>
                                                                    <span className="phrecording">
                                                                        {t("DefaultPersonalizedGreeting")}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <MDBSelect
                                                                        className="w-100"
                                                                        data={[
                                                                            { text: "Personalized", value: 1 },
                                                                            { text: "Two", value: 2 },
                                                                            { text: "Three", value: 3 },
                                                                            { text: "Four", value: 4 },
                                                                            { text: "Five", value: 5 },
                                                                            { text: "Six", value: 6 },
                                                                            { text: "Seven", value: 7 },
                                                                            { text: "Eight", value: 8 },
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="routing-border m-0 pt-1 mb-2"></div>

                                                            <p className="text-secondary phrecording mt-3">
                                                                {t("ListenCurrentGreetingmsg")}
                                                            </p>

                                                            <div className="d-flex align-items-center justify-content-center">

                                                                <audio controls className="mt-3" /><strong className="text-primary mt-3 ms-3">Edit</strong>
                                                            </div>

                                                            <p className="mt-3 text-primary">{t("PersonalizedGreetingActivated")}</p>

                                                        </MDBModalBody>

                                                        <MDBModalFooter>
                                                            <MDBBtn color='secondary' onClick={VoiceMailunavaliableToggle2}>
                                                                Close
                                                            </MDBBtn>
                                                            <MDBBtn>Save changes</MDBBtn>
                                                        </MDBModalFooter>
                                                    </MDBModalContent>
                                                </MDBModalDialog>
                                            </MDBModal>
                                        </div>
                                        <div>
                                            <MDBBtn onClick={VoicemailUnavailableGreetingToggle} className="me-2"> {t("VoicemailUnavailableGreeting")}</MDBBtn>

                                            <MDBModal open={VoicemailUnavailableGreeting} setShow={setVoicemailUnavailableGreeting} tabIndex='-1'>
                                                <MDBModalDialog centered>
                                                    <MDBModalContent>
                                                        <MDBModalHeader>
                                                            <MDBModalTitle> {t("VoiceMailunavaliableGreeting")}</MDBModalTitle>
                                                            <MDBBtn className='btn-close' color='none' onClick={VoicemailUnavailableGreetingToggle}></MDBBtn>
                                                        </MDBModalHeader>
                                                        <MDBModalBody>

                                                            <div className="add-numbermain align-items-baseline">
                                                                <div>
                                                                    <div className="fw-500">
                                                                        {t("GreetingType")}
                                                                    </div>
                                                                    <span className="phrecording">
                                                                        {t("DefaultPersonalizedGreeting")}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <MDBSelect
                                                                        className="w-100"
                                                                        data={[
                                                                            { text: "Personalized", value: 1 },
                                                                            { text: "Two", value: 2 },
                                                                            { text: "Three", value: 3 },
                                                                            { text: "Four", value: 4 },
                                                                            { text: "Five", value: 5 },
                                                                            { text: "Six", value: 6 },
                                                                            { text: "Seven", value: 7 },
                                                                            { text: "Eight", value: 8 },
                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="routing-border m-0 pt-1 mb-2"></div>


                                                        </MDBModalBody>

                                                        <MDBModalFooter>
                                                            <MDBBtn color='secondary' onClick={VoicemailUnavailableGreetingToggle}>
                                                                Close
                                                            </MDBBtn>
                                                            <MDBBtn>Save changes</MDBBtn>
                                                        </MDBModalFooter>
                                                    </MDBModalContent>
                                                </MDBModalDialog>
                                            </MDBModal>
                                        </div>
                                    </div>
                                    <MDBBtn className="m-2" onClick={toggleShow22}>
                                        {t("AddLocWeeklySchedule")}
                                    </MDBBtn>
                                    <MDBModal
                                        open={AddLocationWeekly}
                                        setShow={setAddLocationWeekly}
                                        tabIndex="-1"
                                    >
                                        <MDBModalDialog>
                                            <MDBModalContent className="small-popup">
                                                <MDBModalHeader>
                                                    <MDBModalTitle>{t("addlocation")}</MDBModalTitle>
                                                    <MDBBtn
                                                        className="btn-close"
                                                        color="none"
                                                        onClick={toggleShow22}
                                                    ></MDBBtn>
                                                </MDBModalHeader>
                                                <MDBModalBody>
                                                    <div>
                                                        <div className="tel-numbers">
                                                            <strong>{t("name")}</strong>
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value="Prestige Worldwide"
                                                            />
                                                        </div>
                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("StreetAddress")}</strong>
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                value="Prestige Worldwide"
                                                            />
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                placeholder="Suite, unit, building..."
                                                            />
                                                        </div>
                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("City")}</strong>
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                value="Grants Pass"
                                                            />
                                                        </div>
                                                        <div className="row pt-3">
                                                            <div className="col-6">
                                                                <div className="tel-numbers">
                                                                    <strong>{t("State")}</strong>
                                                                </div>
                                                                <div className="form">
                                                                    <input
                                                                        type="text"
                                                                        value="Oregon"
                                                                        className="w-100"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="tel-numbers">
                                                                    <strong>{t("ZIPCode")}</strong>
                                                                </div>
                                                                <div className="form">
                                                                    <input
                                                                        type="text"
                                                                        value="95727"
                                                                        className="w-100"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="tel-numbers pt-3">
                                                            <strong>{t("PrimaryContact")}</strong>
                                                        </div>
                                                        <div className="row pt-2">
                                                            <div className="col-6">
                                                                <div className="tel-numbers fw-500">
                                                                    {t("firstName")}
                                                                </div>
                                                                <div className="form">
                                                                    <input
                                                                        type="text"
                                                                        value="Jerome"
                                                                        className="w-100"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="tel-numbers fw-500">
                                                                    {t("lastName")}
                                                                </div>
                                                                <div className="form">
                                                                    <input
                                                                        type="text"
                                                                        value="Friesenhahn"
                                                                        className="w-100"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("email")}</strong>
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                value="Jerome@panterranetworks.com "
                                                            />
                                                        </div>
                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("Number")}</strong>
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                value="541 856 9547"
                                                            />
                                                        </div>
                                                        <div className="routing-border my-2"> </div>

                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("911Information")}</strong>
                                                        </div>
                                                        <div className="add-numbermain mt-2">
                                                            <div>
                                                                <div className="tel-numbers">
                                                                    {t("en911services")}
                                                                </div>
                                                            </div>
                                                            <div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="add-numbermain mt-2">
                                                            <div>
                                                                <div className="tel-numbers">
                                                                    {t("UsePrimaryCont")}
                                                                </div>
                                                            </div>
                                                            <div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="tel-numbers mt-2">
                                                            {t("UsePrimaryCont")}
                                                        </div>
                                                        <MDBSelect
                                                            className=" mt-2"
                                                            data={[
                                                                { text: "One", value: 1 },
                                                                { text: "Two", value: 2 },
                                                                { text: "Three", value: 3 },
                                                                { text: "Four", value: 4 },
                                                                { text: "Five", value: 5 },
                                                                { text: "Six", value: 6 },
                                                                { text: "Seven", value: 7 },
                                                                { text: "Eight", value: 8 },
                                                            ]}
                                                        />
                                                        <div className="tel-numbers mt-2">
                                                            {t("Speclocation")}
                                                        </div>
                                                        <div className="form pt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control w-100"
                                                                placeholder="Frontdesk, Server Room, etc.."
                                                            />
                                                        </div>
                                                        <div className="routing-border my-2"></div>

                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("weeklyschedule")}</strong>
                                                        </div>
                                                        <div className="mt-1">
                                                            <div className="d-flex align-items-center justify-content-center">

                                                                <MDBRadio
                                                                    name="inlineRadio"
                                                                    id="inlineRadio1"
                                                                    value="option1"
                                                                    label="24/7"
                                                                    inline
                                                                    checked={selectedOption2 === 'option1'}
                                                                    onChange={() => setSelectedOption2('option1')}
                                                                />
                                                                <MDBRadio
                                                                    name="inlineRadio"
                                                                    id="inlineRadio2"
                                                                    value="option2"
                                                                    label="Weekly Schedule"
                                                                    inline
                                                                    checked={selectedOption2 === 'option2'}
                                                                    onChange={() => setSelectedOption2('option2')}
                                                                />

                                                            </div>
                                                            {selectedOption2 === 'option2' && (
                                                                <>
                                                                    <div className="d-flex align-items-center ">
                                                                        <div className="phoneselect ">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label>Sunday</label>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Monday</label>
                                                                        <label className="w-10">From</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <label className="w-5 ms-2">To</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <div className="check_AddLoc w-10 ms-2">
                                                                            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Tuesday</label>
                                                                        <label className="w-10">From</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <label className="w-5 ms-2">To</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <div className="check_AddLoc w-10 ms-2">
                                                                            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                        </div>
                                                                    </div>


                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Wednsday</label>
                                                                        <label className="w-10">From</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <label className="w-5 ms-2">To</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <div className="check_AddLoc w-10 ms-2">
                                                                            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Thursday</label>
                                                                        <label className="w-10">From</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <label className="w-5 ms-2">To</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <div className="check_AddLoc w-10 ms-2">
                                                                            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Fryday</label>
                                                                        <label className="w-10">From</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <label className="w-5 ms-2">To</label>
                                                                        <div className="inputSelectLoc w-80px ">
                                                                            <MDBSelect
                                                                                data={[
                                                                                    { text: 'One', value: 1 },
                                                                                    { text: 'Two', value: 2 },
                                                                                    { text: 'Three', value: 3 },
                                                                                    { text: 'Four', value: 4 },
                                                                                    { text: 'Five', value: 5 },
                                                                                    { text: 'Six', value: 6 },
                                                                                    { text: 'Seven', value: 7 },
                                                                                    { text: 'Eight', value: 8 },
                                                                                ]}
                                                                            />
                                                                        </div>
                                                                        <div className="check_AddLoc w-10 ms-2">
                                                                            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center mt-2 ">
                                                                        <div className="phoneselect">
                                                                            <label className="switch">
                                                                                <input className="form-control" type="checkbox" />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                        <label className="w-16">Saturday</label>
                                                                    </div>
                                                                </>
                                                            )}
                                                            <div className="tel-numbers mt-2">
                                                                <strong>{t("billingGroup")}</strong>
                                                            </div>
                                                            <div className="form mt-1 d-flex w-100 justify-content-between align-items-center">
                                                                <div className="w-50">
                                                                    <select
                                                                        className="form-select form-control w-100"
                                                                        name="San Jose"
                                                                    >
                                                                        <option value="San Jose">
                                                                            Prestige Worldwide
                                                                        </option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                        <option value="San Jose">San Jose</option>
                                                                    </select>
                                                                </div>
                                                                <div>
                                                                    <MDBCheckbox
                                                                        className="me-0"
                                                                        name="inlineCheck"
                                                                        id="inlineCheckbox1"
                                                                        value="option1"
                                                                        label="Invoice this location"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </MDBModalBody>
                                                <MDBModalFooter>
                                                    <MDBBtn color="secondary" onClick={toggleShow22}>
                                                        {t("close")}
                                                    </MDBBtn>
                                                    <MDBBtn>{t("add")}</MDBBtn>
                                                </MDBModalFooter>
                                            </MDBModalContent>
                                        </MDBModalDialog>
                                    </MDBModal>
                                    <u>
                                        <h3 className="text-center">
                                            Call Flow Popups
                                        </h3>
                                    </u>
                                    <div>
                                        <MDBBtn className="me-2" onClick={NewSchesuleToggle}>Create New Schedule </MDBBtn>
                                        <MDBModal tabIndex='-1' open={NewSchesule} setShow={setNewSchesule}>
                                            <MDBModalDialog centered >
                                                <MDBModalContent>
                                                    <MDBModalHeader>
                                                        <MDBModalTitle>Modal title</MDBModalTitle>
                                                        <MDBBtn className='btn-close' color='none' onClick={NewSchesuleToggle}></MDBBtn>
                                                    </MDBModalHeader>
                                                    <MDBModalBody  >
                                                        <div className="tel-numbers mt-1">
                                                            <strong>{t("weeklyschedule")}</strong>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-center">

                                                            <MDBRadio
                                                                name="inlineRadio"
                                                                id="inlineRadio1"
                                                                value="option1"
                                                                label="24/7"
                                                                inline
                                                                checked={selectedOption2 === 'option1'}
                                                                onChange={() => setSelectedOption2('option1')}
                                                            />
                                                            <MDBRadio
                                                                name="inlineRadio"
                                                                id="inlineRadio2"
                                                                value="option2"
                                                                label="Weekly Schedule"
                                                                inline
                                                                checked={selectedOption2 === 'option2'}
                                                                onChange={() => setSelectedOption2('option2')}
                                                            />

                                                        </div>
                                                        {selectedOption2 === 'option2' && (


                                                            <>
                                                                <div className="d-flex align-items-center ">
                                                                    <div className="phoneselect ">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label>Sunday</label>
                                                                </div>
                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Monday</label>
                                                                    <label className="w-10">From</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <label className="w-5 ms-2">To</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <div className="check_AddLoc w-10 ms-2">
                                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Tuesday</label>
                                                                    <label className="w-10">From</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <label className="w-5 ms-2">To</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <div className="check_AddLoc w-10 ms-2">
                                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                    </div>
                                                                </div>


                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Wednsday</label>
                                                                    <label className="w-10">From</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <label className="w-5 ms-2">To</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <div className="check_AddLoc w-10 ms-2">
                                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Thursday</label>
                                                                    <label className="w-10">From</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <label className="w-5 ms-2">To</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <div className="check_AddLoc w-10 ms-2">
                                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Fryday</label>
                                                                    <label className="w-10">From</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <label className="w-5 ms-2">To</label>
                                                                    <div className="inputSelectLoc w-80px ">
                                                                        <MDBSelect
                                                                            data={[
                                                                                { text: 'One', value: 1 },
                                                                                { text: 'Two', value: 2 },
                                                                                { text: 'Three', value: 3 },
                                                                                { text: 'Four', value: 4 },
                                                                                { text: 'Five', value: 5 },
                                                                                { text: 'Six', value: 6 },
                                                                                { text: 'Seven', value: 7 },
                                                                                { text: 'Eight', value: 8 },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                    <div className="check_AddLoc w-10 ms-2">
                                                                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='24 hours' />
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex align-items-center mt-2 ">
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                    <label className="w-16">Saturday</label>
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="add-numbermain">

                                                            <div className="tel-numbers mt-1">
                                                                <strong>{t("weeklyOverrides")}</strong>
                                                            </div>
                                                            <MDBBtn><MDBIcon fas icon="plus" className="me-2" />{t("addOverride")}</MDBBtn>
                                                        </div>
                                                        <div className="weeklyTable">
                                                            <MDBDatatable hover data={actionData} pagination={false} sortField="Name" />
                                                        </div>
                                                        <div className="add-numbermain">

                                                            <div className="tel-numbers mt-1">
                                                                <strong>{t("Holiday")}</strong>
                                                            </div>
                                                            <MDBBtn><MDBIcon fas icon="plus" className="me-2" />{t("addHoliday")}</MDBBtn>
                                                        </div>
                                                        <div className="weeklyTable">
                                                            <MDBDatatable hover data={actionData2} pagination={false} sortField="Name" />
                                                        </div>
                                                    </MDBModalBody>
                                                    <MDBModalFooter>
                                                        <MDBBtn color='secondary' onClick={NewSchesuleToggle}>
                                                            Close
                                                        </MDBBtn>
                                                        <MDBBtn>Save changes</MDBBtn>
                                                    </MDBModalFooter>
                                                </MDBModalContent>
                                            </MDBModalDialog>
                                        </MDBModal>
                                    </div>
                                    <div className="mt-4">


                                        <MDBPopconfirm placement='bottom-start' btnChildren="Filter">
                                            <MDBPopconfirmMessage>

                                                <div>
                                                    <p className='mb-3 fw-600 filterhead'>
                                                        {(showSeatPlan || showRole) ? (showSeatPlan ? "Seat Plan" : "Role") : "Filter by"}
                                                    </p>
                                                    {!showSeatPlan && !showRole && (
                                                        <>
                                                            <div className="d-flex flex-column ">
                                                                <div className="cursor-pointer" onClick={toggleSeatPlan}>
                                                                    Seat Plan
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-column mt-2">
                                                                <div className="cursor-pointer mt-2" onClick={toggleRole}>
                                                                    Role
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {showSeatPlan && (
                                                        <div>
                                                            <div className="">
                                                                <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Professional' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck' value='' id='flexCheckChecked' label='Call Center' />
                                                            </div>
                                                        </div>
                                                    )}


                                                    {showRole && (
                                                        <div>
                                                            <div className="">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckDefault1' label='Super Admin' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked2' label='Admin' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked3' label='Supervisor' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked4' label='User' />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {showSeatPlan || showRole ? (
                                                    <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                                                        <MDBBtn size='sm' outline color='secondary' onClick={toggleBackClick} className="mx-0">
                                                            Back
                                                        </MDBBtn>
                                                        <div className="me-0">
                                                            <MDBBtn size='sm' color='secondary' onClick={toggleFilter} className="me-2">
                                                                cancel
                                                            </MDBBtn>
                                                            <MDBBtn size='sm'>Apply</MDBBtn>
                                                        </div>
                                                    </MDBModalFooter>
                                                ) : null}


                                            </MDBPopconfirmMessage>
                                        </MDBPopconfirm>


                                        <div className="d-flex">
                                            <div className="ms-4 popconfirmFilter reportsAdjust">
                                                <MDBPopconfirm className="p-0 w-auto" color='light' onClick={() => setIsOpen2(false)} placement='bottom-start' btnChildren={<>
                                                    <div className=" reportsFilter form-select selectname text-start" >
                                                        Select
                                                    </div>
                                                </>}>
                                                    <MDBPopconfirmMessage>
                                                        <div>
                                                            <div className="">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckDefault1' label='Select All' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked2' label='IP Phone 1' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked3' label='Supervisor' />
                                                            </div>
                                                            <div className="mt-2">
                                                                <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked4' label='User' />
                                                            </div>
                                                            <div className="mt-2">
                                                                Add External Number
                                                            </div>
                                                        </div>
                                                    </MDBPopconfirmMessage>
                                                </MDBPopconfirm>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    } />

                <Tooltip anchorSelect=".editTooltip" place="top" className="exampleTooltip">
                    Edit
                </Tooltip>
            </>
        </React.Fragment >
    )
}
export default MediaManagementPopups

